export enum enumScheduleDailyFrequency {
  Once = 1,
  Several
}

export namespace enumScheduleDailyFrequency {
  export function values() {
    return Object.keys(enumScheduleDailyFrequency).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
